import React from "react";

export type DotProps = {
  style?: React.HTMLAttributes<HTMLDivElement>["style"];
};

export const Dot: React.FC<DotProps> = ({ style }) => {
  return <div className="dot" style={style} />;
};
